export default "__VITE_ASSET__rEQICbM5__"